<template>
  <nav
    class="fixed z-50 w-full bg-white top-0 flex flex-wrap items-center justify-between py-3 shadow-md"
  >
  <div class="container mx-auto flex flex-wrap items-center justify-between">
    <div class="relative flex justify-between lg:w-auto lg:static lg:block lg:justify-start">
    <router-link
      class="font-bold leading-relaxed inline-block whitespace-nowrap uppercase logo-title"
      to="/"
    >日商簿記{{grade}}級　例題仕訳攻略</router-link>
    </div>
    <div class="flex lg:flex-grow items-center pr-3">
          <ul v-if="isAuth" class="flex flex-col lg:flex-row list-none ml-auto">
            <li class="nav-item">
              <button class="py-1 flex items-center text-md uppercase font-bold leading-snug hover:opacity-75" v-on:click="toggleDropdown()" ref="btnDropdownRef" style="font-size:1.25em">
                <i class="fas fa-bars"></i>
              </button>
            </li>

          </ul>
        </div>

       <div v-bind:class="{'hidden': !dropdownPopoverShow, 'block': dropdownPopoverShow}" class="bg-white text-base z-50 float-left py-2 list-none text-left rounded shadow-lg mt-1" style="min-width:12rem; z-index:9999" ref="popoverDropdownRef">
          <router-link to="/" class="text-sm py-2 px-4 font-normal block w-full whitespace-nowrap bg-transparent  text-slate-700">
            TOP 
          </router-link>
          <router-link to="/howtouse" class="text-sm py-2 px-4 font-normal block w-full whitespace-nowrap bg-transparent  text-slate-700">
            使い方
          </router-link>
          <!-- <div class="h-0 my-2 border border-solid border-t-0 border-slate-800 opacity-25"></div> -->
          <button @click="reset" class="text-sm py-2 px-4 font-normal block w-full whitespace-nowrap bg-transparent  text-red-700 text-start">
            リセット
          </button>
        </div>
        <div v-if="dropdownPopoverShow" class="overlay" @click="dropdownPopoverShow = false"></div>
  </div>
  </nav>
</template>

<script lang="ts">
import { Component, Prop, Vue, Emit } from "vue-property-decorator";

import StorageService from "../services/storage";
import { createPopper } from "@popperjs/core";
import BasicUtil from "@/services/basicUtil";

@Component
export default class Header extends Vue {
  $refs: any = {
    btnDropdownRef: null,
    popoverDropdownRef: null
  };

  private dropdownPopoverShow:boolean = false
  private grade: number = Number(process.env.VUE_APP_GRADE)
  private isAuth: boolean = false
  mounted() {
    this.isAuth = BasicUtil.isAuth(this.grade)
  }

  toggleDropdown(){
      if(this.dropdownPopoverShow){
        this.dropdownPopoverShow = false;
      } else {
        this.dropdownPopoverShow = true;
        createPopper(this.$refs.btnDropdownRef, this.$refs.popoverDropdownRef, {
          placement: "bottom-start"
        });
      }
    }
  
  reset() {
    if (!confirm("本当にすべての学習履歴をリセットしますか？")) return;
    new StorageService().resetData();
    this.toggleDropdown()
    this.$toasted.show("すべてのデータを削除しました", {
      duration: 2000,
      type: "success",
    });
  }

  public closePop() {
    this.dropdownPopoverShow = false
  }
}
</script>
<style>
.logo-img {
  display: inline;
  width: 90px;
  margin-right: 1em;
}
.logo-title {
  font-weight: bold;
  color: #e20011;
  font-size: 1.4em;
}

.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
}
</style>